<template>
  <div>
    <h6
      style="font-weight: 400; margin: 0px !important; padding: 0px !important"
      v-if="VALUE == true"
    >
      {{ $t("qEntery") }}
    </h6>
    <h6 style="font-weight: 400; margin: 0px !important; padding: 0px !important" v-else>
      {{ $t("qExit") }}
    </h6>
  </div>
</template>
<script>
export default {
  data() {
    return {
      VALUE: "",
    };
  },
  created() {
    this.VALUE = this.params.value;
  },
};
</script>
